import { twMerge } from "tailwind-merge";
import clsx from "clsx";

const Content = ({ className, children }) => {
  return (
    <div className=" h-[calc(100vh-90px)] overflow-y-scroll">
      <div
        className={twMerge(
          clsx("px-9 py-6 grid gap-5 grid-cols-1 items-baseline", className),
        )}
      >
        {children}
      </div>
    </div>
  );
};

export { Content };
